import { MINUTES_IN_HOUR } from '../../minutes-range/timeUtils';
import { InvalidTimezoneOffsetError } from '../../errors';
import { MAX_TIMEZONE_OFFSET, MIN_TIMEZONE_OFFSET } from './constants';
export const DateTimeConverter = {
  toRestaurantDate(clientDate, restaurantTimezoneOffset, clientTimezoneOffset) {
    if (restaurantTimezoneOffset === clientTimezoneOffset) {
      return new Date(clientDate);
    }
    const restaurantDate = new Date(clientDate);
    restaurantDate.setMinutes(restaurantDate.getMinutes() - (clientTimezoneOffset - restaurantTimezoneOffset) * MINUTES_IN_HOUR);
    return restaurantDate;
  },
  fromRestaurantDate(restaurantDate, restaurantTimezoneOffset, clientTimezoneOffset) {
    if (restaurantTimezoneOffset === clientTimezoneOffset) {
      return new Date(restaurantDate);
    }
    const clientDate = new Date(restaurantDate);
    clientDate.setMinutes(clientDate.getMinutes() + (clientTimezoneOffset - restaurantTimezoneOffset) * MINUTES_IN_HOUR);
    return clientDate;
  },
  toUTCDate(date) {
    const utcDate = new Date(date);
    utcDate.setUTCFullYear(date.getFullYear(), date.getMonth(), date.getDate());
    utcDate.setUTCHours(date.getHours(), date.getMinutes(), date.getSeconds(), 0);
    return utcDate;
  },
  validateTimezoneOffset(timezoneOffset) {
    if (timezoneOffset < MIN_TIMEZONE_OFFSET || timezoneOffset > MAX_TIMEZONE_OFFSET) {
      throw new InvalidTimezoneOffsetError(`Timezone offset has to be a number between ${MIN_TIMEZONE_OFFSET} and ${MAX_TIMEZONE_OFFSET}`);
    }
    return true;
  }
};
//# sourceMappingURL=date-time-converter.js.map